<template>
    <pendo-card class="import-feedback-drawer-review-step__card">
        <div class="import-feedback-drawer-review-step__header">
            <img
                class="import-feedback-drawer-guide-review-step__header-image"
                src="@img/voc/NPS-import-review.svg"
                width="131"
                height="92">
            <h3>Import complete</h3>
            <p class="import-feedback-drawer-review-step__header-subtitle">
                Feedback items have been imported.<br>
                Download CSV to review errors.
            </p>
            <import-feedback-drawer-csv-bar-card :file-name="displayName" />
        </div>
        <div class="import-feedback-drawer-review-step__footer">
            <div class="import-feedback-drawer-review-step__stat-section">
                <div class="import-feedback-drawer-review-step__stat-percentage-section">
                    <img
                        class="import-feedback-drawer-review-step__stat-percentage-image"
                        src="@img/voc/successful-uploads.svg"
                        width="40"
                        height="40">
                    <p class="import-feedback-drawer-review-step__stat-percentage">
                        {{ successfulPercentage }}%
                    </p>
                </div>
                <p class="import-feedback-drawer-review-step__stat-uploads">
                    Successful imports
                </p>
                <p class="import-feedback-drawer-review-step__stat-upload-stat">
                    ({{ successfulStat }})
                </p>
                <pendo-button
                    v-if="savedViewCreated"
                    data-cy="import-feedback-drawer-review-step-view-insights-button"
                    theme="app"
                    type="subtle"
                    label="View insights"
                    @click="$emit('view-insights')" />
            </div>
            <div class="import-feedback-drawer-review-step__stat-section">
                <div class="import-feedback-drawer-review-step__stat-percentage-section">
                    <img
                        class="import-feedback-drawer-review-step__stat-percentage-image"
                        src="@img/voc/failed-uploads.svg"
                        width="40"
                        height="40">
                    <p class="import-feedback-drawer-review-step__stat-percentage">
                        {{ failedPercentage }}%
                    </p>
                </div>
                <p class="import-feedback-drawer-review-step__stat-uploads">
                    Unsuccessful imports
                </p>
                <p class="import-feedback-drawer-review-step__stat-upload-stat">
                    ({{ failedStat }})
                </p>
                <pendo-button
                    v-if="failedItems > 0"
                    theme="app"
                    type="subtle"
                    label="Download error CSV"
                    @click="$emit('generate-csv-errors')" />
            </div>
        </div>
    </pendo-card>
</template>

<script>
import { PendoCard, PendoButton } from '@pendo/components';
import ImportFeedbackDrawerCsvBarCard from '@/voc/components/drawers/import-feedback-drawer/components/import-feedback-drawer-csv-bar-card.vue';

export default {
    name: 'ImportFeedbackDrawerCsvReviewStep',
    components: {
        ImportFeedbackDrawerCsvBarCard,
        PendoCard,
        PendoButton,
    },
    props: {
        displayName: {
            type: String,
            required: true,
        },
        successfulPercentage: {
            type: Number,
            required: true,
        },
        successfulStat: {
            type: String,
            required: true,
        },
        failedPercentage: {
            type: Number,
            required: true,
        },
        failedStat: {
            type: String,
            required: true,
        },
        failedItems: {
            type: Number,
            required: true,
        },
        savedViewCreated: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['view-insights', 'view-insights-new-tab', 'generate-csv-errors'],
};
</script>

<style lang="less" scoped>
@import '@/voc/styles/voc.style.less';
.import-feedback-drawer-review-step {
    .pendo-card {
        :deep(.pendo-card__body) {
            padding: 32px;
        }
    }

    &__card {
        display: flex;
        flex-direction: column;
        width: 480px;
        margin: auto;
    }

    &__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        & h3 {
            font-weight: 600;
            margin-top: 16px;
            margin-bottom: 10px;
        }

        &-subtitle {
            line-height: 150%;
        }
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        grid-gap: 16px;
    }

    &__stat {
        &-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-top: 16px;
            text-align: center;
            border-radius: 4px;
            width: 50%;
        }

        &-percentage-section {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 4px;
        }

        &-percentage-image {
            width: 40px;
            height: 40px;
            margin-right: 10px;
        }

        &-percentage {
            font-size: 28px;
            font-weight: 600;
            margin-bottom: 0;
        }

        &-uploads {
            margin-bottom: 6px;
        }

        &-upload-stat {
            margin-bottom: 10px;
            color: var(--palette-gray-70);
        }
    }
}
</style>
